import { BackgroundThemeProvider } from '@/context/BackgroundThemeContextProvider';
import { cn } from '@/utils/cn';
import type { FC, ReactNode } from 'react';

interface FooterProps {
  actionButtons: ReactNode;
  content?: ReactNode;
}

const Footer: FC<FooterProps> = ({ actionButtons, content }) => {
  if (!actionButtons && !content) {
    return null;
  }

  return (
    <BackgroundThemeProvider backgroundTheme="white">
      <footer
        className={cn(
          'fixed bottom-0 left-0 right-0 flex w-full justify-center border-t bg-white text-dark'
        )}
      >
        <div
          id="footer-wrapper"
          className={cn(
            'flex w-full max-w-laptop flex-col gap-4 p-4 laptop:flex-row laptop:items-center',
            {
              'laptop:justify-end': !content,
              'laptop:justify-between': !!content,
            }
          )}
        >
          {content && <div id="footer-content">{content}</div>}
          {actionButtons && (
            <div id="footer-buttons" className="flex gap-2">
              {actionButtons}
            </div>
          )}
        </div>
      </footer>
    </BackgroundThemeProvider>
  );
};

export default Footer;
